<template>
  <div
    v-if="user"
    class="row app-wrap align-center rounded flex tournament-white pl-4 elevate-3d elevate-3 tournament-light-blue-outline"
    style="min-height: 68px; border-left: 10px solid"
  >
    <div class="column my-2 flex">
      <!-- User name -->
      <div v-if="user.name" class="row align-center">
        <div class="tournament-dark-blue--text subheading">
          {{ user.name }}
        </div>
        <div v-if="user.birth">
          <div
            class="mx-2 tournament-light-blue"
            style="border-radius: 50%; width: 6px; height: 6px"
          />
        </div>
        <div v-if="user.birth" class="tournament-dark-blue--text subheading">
          {{ user.birth | FormatDate("age") }} anos
        </div>
      </div>

      <!-- User email -->
      <div v-if="user.alias" class="row body-1 tournament-dark-grey--text">
        {{ user.alias }}
      </div>
    </div>

    <div v-if="showDocument" class="mr-3">
      <el-tooltip effect="dark">
        <div slot="content">
          <div v-if="!hasDocument">
Nenhum arquivo anexado
</div>
          <div v-if="hasDocument">
Arquivos anexados:
</div>
          <div
            v-for="document in userDocuments"
            v-if="hasDocument"
            :key="documents.name"
          >
            {{ document.name }}
          </div>
        </div>
        <v-icon
          light
          size="20"
          :color="hasDocument ? 'tournament-green' : 'tournament-grey'"
        >
          attach_file
        </v-icon>
      </el-tooltip>
    </div>

    <div v-if="enrollmentStatus == 'waiting'" class="row align-center">
      <div class="border-left border-right">
        <el-button
          class="tournament-light-blue--text caption"
          style="height: calc(100% - 8px); width: 68px"
          type="text"
          @click.native="edit()"
        >
          EDITAR
        </el-button>
      </div>

      <el-button
        type="text"
        class="ml-0"
        style="width: 68px"
        @click.native="remove()"
      >
        <v-icon color="tournament-grey">
close
</v-icon>
      </el-button>
    </div>

    <div v-else class="column border-left">
      <el-button
        class="tournament-light-blue--text caption"
        style="width: 90px"
        type="text"
        @click.native="edit()"
      >
        VER MAIS
      </el-button>
    </div>
  </div>
</template>

<script>
import _ from "lodash";

export default {
  name: "UsersCard",

  props: {
    user: {
      type: Object,
    },
    enrollmentStatus: {
      type: String,
    },
    documents: {},
  },

  computed: {
    showDocument() {
      return true; //!!this.documents
    },
    userDocuments() {
      return this.showDocument
        ? this.documents.filter((doc) => doc.name.includes(this.user.alias))
        : [];
    },
    hasDocument() {
      return this.userDocuments && this.userDocuments.length;
    },
  },

  created() {
    // Keep safe when parent pass a undefined as prop
    if (!this.user) {
      this.$emit("input", {});
    }
  },

  methods: {
    remove() {
      if (!_.get(this.user, "_id")) return;

      this.$emit("remove", this.user._id);
    },

    edit() {
      if (!_.get(this.user, "_id")) return;

      this.$emit("edit", this.user);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Users/Card/index.vue